export const REQUEST_DELETE_LIBRARY_CREATIVE = 'REQUEST_DELETE_LIBRARY_CREATIVE';
export const DELETE_LIBRARY_CREATIVE_SUCCESS = 'DELETE_LIBRARY_CREATIVE_SUCCESS';
export const DELETE_LIBRARY_CREATIVE_ERROR = 'DELETE_LIBRARY_CREATIVE_ERROR';

export const SAVE_LIBRARY_CREATIVE_SUCCESS = 'SAVE_LIBRARY_CREATIVE_SUCCESS';
export const SAVE_LIBRARY_CREATIVE_ERROR = 'SAVE_LIBRARY_CREATIVE_FAILURE';
